import React from 'react';
import {
  string, arrayOf, bool, shape,
} from 'prop-types';
import { Grid } from '@material-ui/core';
import DefaultContainer from '../../DefaultContainer';
import Image from '../../Image';
import styles from './style.module.scss';

const ImageGrid = ({ images, isWeb, isAndroid }) => (
  <DefaultContainer
    justify="center"
    alignItems={images.length === 3 ? 'center' : 'flex-start'}
    className={styles.container}
  >
    <Grid
      item
      xs={12}
      md={6}
    >
      {
        images.map((xtraImg, index) => (
          <Grid item key={xtraImg.main || xtraImg.fall}>
            {
              (index % 2) ? (
                <Image
                  source={xtraImg}
                  alt="case frame"
                  style={isWeb ? {
                    marginTop: images.length !== 3 && index === 1 && '35%',
                    width: '100%',
                  } : {
                    marginBottom: index !== images.length - 1 && '50px',
                    marginTop: images.length !== 3 && index === 1 && '64%',
                  }}
                  className={[
                    styles.imageLeft,
                    isAndroid && styles.imageAndroid,
                  ].join(' ')}
                />
              ) : <Grid item />
            }
          </Grid>
        ))
      }
    </Grid>
    <Grid item xs={12} md={6}>
      {
        images.map((xtraImg, index) => (
          <Grid item key={xtraImg.main || xtraImg.fall}>
            {
              !(index % 2) ? (
                <Image
                  source={xtraImg}
                  alt="case frame"
                  style={isWeb ? {
                    width: '100%',
                  } : {
                    marginBottom: !isWeb && index !== images.length - 1 && '50px',
                  }}
                  className={[
                    styles.imageRight,
                    isAndroid && styles.imageAndroid,
                  ].join(' ')}
                />
              ) : <Grid item />
            }
          </Grid>
        ))
      }
    </Grid>
  </DefaultContainer>
);

ImageGrid.propTypes = {
  images: arrayOf(shape({
    main: string,
    fall: string,
  })).isRequired,
  isWeb: bool,
  isAndroid: bool,
};

ImageGrid.defaultProps = {
  isWeb: false,
  isAndroid: false,
};

export default ImageGrid;
